import React from 'react'
import { Path } from 'react-native-svg'
import styled from 'styled-components/native'

import { AccessibleSvg } from 'ui/svg/AccessibleSvg'
import { AccessibleIcon } from 'ui/svg/icons/types'

const SpeakerSvg: React.FunctionComponent<AccessibleIcon> = ({
  size,
  color,
  accessibilityLabel,
  testID,
}) => {
  const height = typeof size === 'string' ? size : ((size as number) * 156) / 200
  return (
    <AccessibleSvg
      width={size}
      height={height}
      viewBox="0 0 150 117"
      accessibilityLabel={accessibilityLabel}
      testID={testID}>
      <Path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.1799 90.1726C50.8777 93.2598 53.0162 95.7332 55.998 95.9277L62.9898 96.3844C64.0672 96.4547 64.777 97.3541 64.7114 98.2981C64.6458 99.242 63.833 100.038 62.7415 99.9635L55.7146 99.4856C50.7746 99.1507 47.2612 94.8924 47.6055 90.0157L47.8749 86.2141L37.0253 85.6074C35.5098 85.5231 33.8187 86.4273 32.2751 86.7856C28.5414 87.6476 24.8031 85.6192 23.8006 81.848L21.2428 72.2516C20.2028 68.3493 22.6107 64.7141 26.4216 63.6858L30.8627 62.4865L80.9459 28.9212L80.2011 25.4757C79.3789 21.6765 82.0234 18.1443 85.6118 17.2237C89.1346 16.3196 93.3578 18.2028 94.3767 22.0208L112.284 89.0787C113.293 92.8546 110.349 96.375 107.044 97.2745C103.427 98.2583 99.593 96.3633 98.2767 92.7585C97.8878 91.6951 97.6583 90.6645 97.321 89.4652L86.9258 88.7602L86.5276 93.1918C86.1154 97.7804 82.0538 101.137 77.484 100.891L74.7411 100.743C73.6824 100.687 72.9985 99.6941 73.0734 98.8532C73.1671 97.7945 74.0174 97.0871 75.1229 97.1808L77.2521 97.3612C80.0699 97.6001 82.7026 95.6887 82.8924 92.7679L83.1664 88.54L51.5406 86.4671L51.1775 90.1749L51.1799 90.1726ZM108.709 89.3973L90.9968 23.1638C90.4463 21.1026 88.2188 20.1774 86.3051 20.7302C84.8388 21.1518 83.1945 23.0842 83.7075 25.0189L101.333 91.407C101.881 93.4729 104.219 94.3349 106.011 93.7985C107.562 93.3324 109.271 91.5101 108.707 89.3996L108.709 89.3973ZM38.3065 82.0261L96.2529 85.8253L82.0398 32.5167L33.6266 64.9014L38.3065 82.0284V82.0261ZM27.3281 80.9299C27.8434 82.8178 29.8039 83.7453 31.5185 83.2839L34.7696 82.4079L30.4223 66.3302L27.0236 67.2508C25.2622 67.7286 24.2058 69.497 24.6954 71.2889L27.3281 80.9299Z"
      />
      <Path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.005 45.933C109.192 46.7482 108.159 46.7482 107.452 46.1251C106.81 45.5583 106.553 44.3473 107.288 43.6095L117.121 33.7811C117.796 33.1065 119 33.4532 119.435 33.9146C120.176 34.7017 120.129 35.7815 119.384 36.5263L110.003 45.9307L110.005 45.933Z"
      />
      <Path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M125.84 67.0572L112.821 63.5976C111.744 63.3119 111.308 62.1923 111.636 61.2553C111.964 60.3184 112.903 59.9272 113.964 60.2107L126.362 63.511C127.428 63.7944 128.128 64.3659 127.981 65.5441C127.889 66.2819 126.976 67.357 125.838 67.0549L125.84 67.0572Z"
      />
      <Path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.593 54.4901C112.506 54.7782 111.604 53.8272 111.429 53.0988C111.187 52.1056 111.885 51.2835 112.918 51.0071L125.651 47.6154C126.614 47.3578 127.492 48.0066 127.734 48.8006C127.996 49.6556 127.588 50.7682 126.562 51.0399L113.591 54.4901H113.593Z"
      />
    </AccessibleSvg>
  )
}

export const Speaker = styled(SpeakerSvg).attrs(({ color, size, theme }) => ({
  color: color ?? theme.designSystem.color.icon.default,
  size: size ?? theme.illustrations.sizes.medium,
}))``
